class ListFiltersComponent {
    constructor(rootEl) {
        this.rootEl = rootEl;

        this.filterComponents = [];

        this.urlQueryString = window.location.href.split('?')[1];

        this.init();
    }

    init() {
        const filterEls = document.querySelectorAll('.filtresContenus__element');

        filterEls.forEach((filterEl) => {
            this.filterComponents.push(new FilterComponent(filterEl, this.urlQueryString));
        });
    }
}

class FilterComponent {
    constructor(rootEl, urlQueryString) {
        this.rootEl = rootEl;
        this.urlQueryString = urlQueryString;
        this.optionLinkEls = this.rootEl.querySelectorAll('a.filtresContenus__optionLink');
        this.toggleEl = this.rootEl.querySelector('.filtresContenus__toggle');
        this.optionsListContainerEl = this.rootEl.querySelector(
            '.filtresContenus__optionsListContainer'
        );
        this.toggleTextEl = this.rootEl.querySelector('.filtresContenus__toggleText');
        this.filtersType = this.rootEl.getAttribute('data-filters-type');

        this.selectToggled = false;

        this.init();
    }

    init() {
        // Initialisation filtres
        if (this.urlQueryString != undefined) {
            this.optionLinkEls.forEach((optionLinkEl) => {
                if (optionLinkEl.getAttribute('data-filter-reset') != null) {
                    return;
                }
                const optionHrefQueryString = optionLinkEl.href.split('?')[1];

                if (
                    optionHrefQueryString &&
                    optionHrefQueryString != '' &&
                    this.urlQueryString.indexOf(optionHrefQueryString) > -1
                ) {
                    this.selectOption(optionLinkEl);
                }
            });
        }

        this.addOptionsClickEvents();
        this.addToggleClickEvent();
        this.updateDisplay();
    }

    addOptionsClickEvents() {
        // Initialisation filtres
        if (this.urlQueryString != undefined) {
            // Event de clic sur un des filtres
            this.optionLinkEls.forEach((optionLinkEl) => {
                optionLinkEl.addEventListener('click', (e) => {
                    e.preventDefault();

                    // Objet stockant les paramètres d'URL
                    let queryData = {};

                    // Ajouts des paramètres GET de l'URL dans queryData
                    if (this.urlQueryString != undefined) {
                        const urlQueryOptionsString = this.urlQueryString.split('&');

                        urlQueryOptionsString.forEach((queryString) => {
                            const queryKeyValueString = queryString.split('=');
                            queryData[queryKeyValueString[0]] = queryKeyValueString[1];
                        });
                    }

                    // Ajout du paramètre cliqué dans queryData
                    const targetOptionHrefQueryString = e.target.href.split('?')[1];

                    if (targetOptionHrefQueryString != undefined) {
                        const targetOptionHrefQueryOptionsString =
                            targetOptionHrefQueryString.split('&');

                        targetOptionHrefQueryOptionsString.forEach((queryString) => {
                            const queryKeyValueString = queryString.split('=');

                            queryData[queryKeyValueString[0]] = queryKeyValueString[1];
                        });
                    }

                    // Si un attribut "data-filter-reset" est présent sur le filtre, suppression de ce paramètre dans queryData
                    const filterKeyToReset = e.target.getAttribute('data-filter-reset');

                    if (filterKeyToReset != null) {
                        delete queryData[filterKeyToReset];
                    }

                    // Construction de l'URL finale
                    let finalQueryString = '';

                    const objectLength = Object.keys(queryData).length;

                    if (objectLength > 0) {
                        finalQueryString = '?';

                        Object.keys(queryData).forEach(function (key, index) {
                            const value = queryData[key];

                            if (value == undefined) return;

                            finalQueryString += `${key}=${value}`;

                            if (index < objectLength - 1) {
                                finalQueryString += '&';
                            }
                        });
                    }

                    window.location =
                        window.location.origin + window.location.pathname + finalQueryString;
                });
            });
        }
    }

    addToggleClickEvent() {
        this.toggleEl.addEventListener('mouseover', () => {
            this.toggle();
        });
    }

    toggle() {
        this.selectToggled = !this.selectToggled;
        this.updateDisplay(this.selectToggled);
    }

    updateDisplay(open = false) {
        this.optionsListContainerEl.style.display = open ? 'block' : 'none';

        if (open) {
            this.toggleEl.classList.add('filtresContenus__toggle--open');
            this.optionsListContainerEl.classList.add(
                'filtresContenus__optionsListContainer--open'
            );
        } else {
            this.toggleEl.classList.remove('filtresContenus__toggle--open');
            this.optionsListContainerEl.classList.remove(
                'filtresContenus__optionsListContainer--open'
            );
        }
    }

    selectOption(optionLinkEl) {
        optionLinkEl.classList.add('filtresContenus__optionLink--selected');
        this.toggleTextEl.innerText = optionLinkEl.innerText;
    }
}

class ButtonFiltersComponent {
    constructor(filtresContenusEl) {
        this.rootEl = filtresContenusEl;
        this.buttonEls = this.rootEl.querySelectorAll('.filtresContenus__button');

        this.init();
    }

    init() {
        const currentURL = window.location.href;
        let isMatchFound = false;

        this.buttonEls.forEach(function (button, index) {
            if (index === 0) {
                button.classList.add('button--primary');
                button.classList.remove('button--secondary');
            }

            if (currentURL.includes(button.getAttribute('href'))) {
                button.classList.add('button--primary');
                button.classList.remove('button--secondary');
                isMatchFound = true;
            } else {
                button.classList.remove('button--primary');
                button.classList.add('button--secondary');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const filtresContenusEl = document.querySelector('.filtresContenus');

    const filtersType = filtresContenusEl.getAttribute('data-filters-type');

    switch (filtersType) {
        case 'liste':
            new ListFiltersComponent(filtresContenusEl);
            break;
        case 'bouton':
            new ButtonFiltersComponent(filtresContenusEl);
            break;
    }
});
